import { createFileRoute } from '@tanstack/react-router';

import { getTeamMemberQueryOption } from '@/_pages/team-members/api-service';
import Loading from '@/_pages/team-members/commission-periods/loading';

export const Route = createFileRoute('/_private/team-members/_template/$id/commission-periods')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getTeamMemberQueryOption(opts.params.id)),
  staticData: {
    pageTitle: 'Commission Periods',
    tabKey: 'team-member/commission-periods',
  },
  pendingComponent: Loading,
});
